import { createConfirmationCreater, createMountPoint, createReactTreeMounter } from 'react-confirm';
import DeleteDialog from './delete_dialog';
import ConfirmDialog from './confirm_dialog';
import TokenDialog from './token_dialog';
import DeactivateDialog from './deactivate_dialog';
import ActivateDialog from './activate_dialog';
import ImportDialog from './import_dialog';
import ExportDialog from './export_dialog';
import LogoutDialog from './logout_dialog';
import IssueDialog from './issue_dialog';
import DisconnectDialog from './disconnect_dialog';
import tracking_number_range_dialog from './tracking_number_range_dialog';
import import_dialog_courier from './import_dialog_courier';
import InboundImportDialog from './import_dialog_inbound';
import InboundWithoutPoImportDialog from './import_dialog_inbound_without_po';
import stock_management_dialog from './stock_management_dialog';
import LotExpirationBulkDialog from './lot_expiration_bulk_dialog';
import PrintlabelDialog from './print_label_dialog';
import PrintLabelTypeDialog from './print_label_type_dialog';
import PrintSizeConfirmDialog from './print_size_confirm_dialog';
import ToteScanDialog from './tote_scan_dialog';
import ScanSelectDialog from './scan_select_dialog';
import CompleteDialog from './complete_dialog';
import LeaveDialog from './leave_dialog';
import OutboundIssueDialog from './outbound_issue_dialog';
import ReturnFeeDialog from './return_fee_dialog';
import ReturnFeeEditDialog from './return_fee_edit_dialog';

const mounter = createReactTreeMounter();

export const createConfirmation = createConfirmationCreater(mounter);
export const MountPoint = createMountPoint(mounter);

export const deleteConfirm = createConfirmation(DeleteDialog);
export const disconnectConfirm = createConfirmation(DisconnectDialog);
export const deactivateConfirm = createConfirmation(DeactivateDialog);
export const activateConfirm = createConfirmation(ActivateDialog);
export const confirm = createConfirmation(ConfirmDialog);
export const tokenConfirm = createConfirmation(TokenDialog);
export const importConfirm = createConfirmation(ImportDialog);
export const exportConfirm = createConfirmation(ExportDialog);
export const logoutConfirm = createConfirmation(LogoutDialog);
export const issueConfirm = createConfirmation(IssueDialog);
export const trackingConfirm = createConfirmation(tracking_number_range_dialog);
export const importDialogCourier = createConfirmation(import_dialog_courier);
export const importInboundConfirm = createConfirmation(InboundImportDialog);
export const importInboundWithoutPoConfirm = createConfirmation(InboundWithoutPoImportDialog);
export const stockConfirm = createConfirmation(stock_management_dialog);
export const lotExpirationBulkConfirm = createConfirmation(LotExpirationBulkDialog);
export const printlabelConfirm = createConfirmation(PrintlabelDialog);
export const printLabelTypeConfirm = createConfirmation(PrintLabelTypeDialog);
export const printSizeConfirm = createConfirmation(PrintSizeConfirmDialog);
export const toteScanConfirm = createConfirmation(ToteScanDialog);
export const scanSelectConfirm = createConfirmation(ScanSelectDialog);
export const completeConfirm = createConfirmation(CompleteDialog);
export const leaveConfirm = createConfirmation(LeaveDialog);
export const outboundIssueConfirm = createConfirmation(OutboundIssueDialog);
export const returnFeeConfirm = createConfirmation(ReturnFeeDialog);
export const returnFeeEditConfirm = createConfirmation(ReturnFeeEditDialog);
